export default __webpack_public_path__ + "static/media/633.b0b9da44.png";